import { makeObservable, observable, action, computed } from 'mobx'
import Checklist from './Checklist'
import {
  ProviderChecklist,
  ProviderChecklistFetchParams,
} from '../providers/types'
import BaseProvider from '../providers/BaseProvider'
import Store from './Store'

export default class ChecklistCollection {
  items: Checklist[] = []
  store: Store
  provider: BaseProvider
  state: 'initialized' | 'ready' | 'loading' | 'failed' = 'initialized'
  defaultParams: ProviderChecklistFetchParams

  constructor(store: Store, defaultParams?: ProviderChecklistFetchParams) {
    makeObservable(this, {
      items: observable,
      state: observable,
      fromProvider: action,
      setState: action,
      isLoading: computed,
      isReady: computed,
    })
    this.defaultParams = defaultParams || {}
    this.store = store
    this.provider = store.provider
  }

  setState(newState: ChecklistCollection['state']) {
    this.state = newState
  }

  get isReady() {
    return this.state === 'ready'
  }

  get isLoading() {
    return this.state === 'loading'
  }

  getIsReady() {
    return this.state === 'ready'
  }

  async fetch(fetchParams?: ProviderChecklistFetchParams) {
    const params = fetchParams || this.defaultParams
    this.setState('loading')
    try {
      const data = await this.provider.fetchChecklists(params)
      this.fromProvider(data)
      this.setState('ready')
    } catch {
      this.setState('failed')
    }
  }

  fromProvider = (data: ProviderChecklist[]) => {
    this.items = data.map((item) => {
      const converted = new Checklist(this.store)
      // converted.fromProvider(item)
      converted.id = item.id
      converted.name = item.name
      converted.complete = item.complete
      converted.creatorId = item.creatorId || ''
      converted.completed_at = item.completedAt
        ? new Date(item.completedAt)
        : undefined
      converted.created_at = item.createdAt
        ? new Date(item.createdAt)
        : undefined
      return converted
    })
  }
}
